var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"breadcrumb__item"},[_c('span',{class:{'breadcrumb__item--clickable' : _vm.clickable},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]),_c('span',{staticClass:"breadcrumb__item--divider",class:{'is-multiple-leveled-item': _vm.isMultipleLeveledItem}},[_vm._v("/")])])
}
var staticRenderFns = []

export { render, staticRenderFns }